// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__yTh6Y","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__cbLHz"};